import { Component, Input, OnChanges } from '@angular/core';
import { PACIMPgpWithProvider } from '@core/model';
import { PremierHealthIncInterface } from '@feature/auth-request-pacim/models/premier-health-inc.interface';
import { ServicingFacilityDetails } from '@feature/auth-request-pacim/models/servicing-facility-details.interface';
import { premierHealthColsConfig } from '../premier-health-cols.config';
import { servicingFacilityColsConfig } from '../servicing-facility-cols.config';
import { TableColumnConfig } from '@shared/model';
import { GOLD_CARD_AUTH_TYPE_HEADER, GOLD_CARD_HEADER } from '@shared/constants/goldcardprovider.constant';

@Component({
    selector: 'servicing-facility-panel-info',
    templateUrl: './servicing-facility-panel-info.component.html',
    styleUrls: ['./servicing-facility-panel-info.component.scss'],
    standalone: false
})
export class ServicingFacilityPanelInfoComponent implements OnChanges {
  @Input() tenantName = '';
  @Input() providerAccountDTO: PACIMPgpWithProvider;
  @Input() isGoldCardVisible = false;

  premierHealthCols = premierHealthColsConfig;
  facilityCols = servicingFacilityColsConfig;
  servicingFacilityCols: TableColumnConfig[];
  servicingFacilityDetails: ServicingFacilityDetails[];
  premierHealthIncData: PremierHealthIncInterface[];

  locationData: {
    phone: string;
    fax: string;
    faxConfirmed: boolean;
    faxConfirmedDate: string;
  };

  ngOnChanges(): void {
    this.onInitPremierHealth();
    this.onInitServicingFacilityDetails();
    this.onInitLocationData();
    this.servicingFacilityCols = this.facilityCols.filter(col => this.isGoldCardVisible || col.header !== GOLD_CARD_HEADER);
    this.servicingFacilityCols = this.servicingFacilityCols.filter(col => this.isGoldCardVisible && this.providerAccountDTO.isGoldCardProvider || col.header !== GOLD_CARD_AUTH_TYPE_HEADER);
  }

  onInitPremierHealth(): void {
    if (this.providerAccountDTO) {
      this.premierHealthIncData = [
        {
          physicalStreet: this.providerAccountDTO.physicalStreet,
          physicalCity: this.providerAccountDTO.physicalCity,
          physicalState: this.providerAccountDTO.physicalState,
          physicalZip: this.providerAccountDTO.physicalZip
        }
      ];
    }
  }

  onInitServicingFacilityDetails(): void {
    if (this.providerAccountDTO) {
      this.servicingFacilityDetails = [
        {
          companyName: this.providerAccountDTO.parentCompany,
          npi: this.providerAccountDTO.npi,
          network: this.getNetwork(),
          outOfNetwork: this.providerAccountDTO.outOfMembersNetwork,
          taxId: this.providerAccountDTO.taxId,
          cms: this.providerAccountDTO.cmsnumber,
          medicaid: this.providerAccountDTO.medicaidNumber,
          isGoldCardProvider: this.providerAccountDTO.isGoldCardProvider,
          goldCardAuthorizationType: this.providerAccountDTO.facilityServiceType
        }
      ];
    }
  }

  onInitLocationData(): void {
    if (this.providerAccountDTO) {
      this.locationData = {
        phone: this.providerAccountDTO.locationPhone,
        fax: this.providerAccountDTO.locationFax,
        faxConfirmed: this.providerAccountDTO.locationFaxConfirmed,
        faxConfirmedDate: this.providerAccountDTO.faxConfirmedDate
      };
    }
  }

  private getNetwork(): string {
    const network = this.providerAccountDTO?.participatingNetworks;

    return network || this.tenantName || 'N/A';
  }
}
